import { getTypeFromFileTypeName, oneDriveConsumerUrlRegex, } from '@office-start/file-utility';
import { format } from '@office-start/string-formatter-utility';
import { decodeUrl } from '@office-start/url-parser-utility';
export function isOneDriveForBusinessFile(source) {
    // Note: KVCache uses "OneDrive", where-as WSET uses "OneDriveForBusiness"
    if (!source) {
        return false;
    }
    var sourceLowerCase = source.toLowerCase();
    return (sourceLowerCase === 'onedriveforbusiness' ||
        sourceLowerCase === 'onedrive');
}
export function isSharePointFile(source) {
    return (source === null || source === void 0 ? void 0 : source.toLowerCase()) === 'sharepoint';
}
// This function processes first name from full display name, which might not work in certain languages/locales
// The ideal solution is where server returns first/last names from the API, but it might not be a bug-level work.
export function getFirstName(fullName) {
    var nameRegex = /\S+/;
    fullName = fullName.trim();
    var onlyFirstName = fullName === null || fullName === void 0 ? void 0 : fullName.match(nameRegex);
    if (!onlyFirstName || onlyFirstName.length === 0) {
        return fullName;
    }
    var firstName = onlyFirstName[0];
    // Some users have "," in their display names that look like "Doe, John", so the logic below
    // checks the last character of the "first name" for "," and return the latter part of the name
    if (firstName.charAt(firstName.length - 1) === ',' &&
        firstName.length !== fullName.length) {
        return fullName.substring(fullName.indexOf(',') + 1);
    }
    return firstName;
}
export function getPathArray(props) {
    var containerTitle = props.containerTitle, filePathTitleLocString = props.filePathTitleLocString, isConsumerFileOwner = props.isConsumerFileOwner, isLocalFile = props.isLocalFile, isOneDriveForBusinessFile = props.isOneDriveForBusinessFile, isSharePointFile = props.isSharePointFile, oneDrivePathTitleLocString = props.oneDrivePathTitleLocString, sitePath = props.sitePath, webUrl = props.webUrl, url = props.url, yourOneDrivePathTitleLocString = props.yourOneDrivePathTitleLocString;
    var pathArray = [];
    // No need to check for email attachment since we always show subject in item template
    if (isLocalFile) {
        pathArray = [webUrl || ''];
    }
    else if (isSharePointFile) {
        if (containerTitle) {
            pathArray = [containerTitle];
        }
        else if (sitePath) {
            pathArray = sitePath.replace('https://', '').split('/');
        }
    }
    else if (isOneDriveForBusinessFile) {
        if (containerTitle) {
            pathArray = [format(filePathTitleLocString, containerTitle)];
        }
        else if (url) {
            // If url is malformed decoding can throw error
            var decodedUrl = decodeUrl(url);
            if (decodedUrl) {
                var path = decodedUrl.split('://');
                if (path.length > 1) {
                    pathArray = path[1].split('/');
                    pathArray.pop();
                }
            }
        }
    }
    else if (url && url.match(oneDriveConsumerUrlRegex)) {
        if (isConsumerFileOwner) {
            pathArray = [yourOneDrivePathTitleLocString];
            var splitStrings = url.split('/');
            /**
             * ODC urls are expected to be in the format "https://d.docs.live.net/<driveId>/file.txt", and if they are in a folder,
             * "https://d.docs.live.net/<driveId>/<folder>/file.txt". Nested folders is possible, but we just need to take the immediate
             * parent folder of the file, which is done by the code below. When url is splitted by '/' and the result has length of
             * > 5, then the file is not in root folder.
             */
            if (splitStrings.length > 5) {
                pathArray.push(splitStrings[splitStrings.length - 2]);
            }
        }
        else if (containerTitle) {
            pathArray = [format(oneDrivePathTitleLocString, containerTitle)];
        }
    }
    else if (containerTitle) {
        pathArray = [containerTitle];
    }
    return pathArray;
}
/**
 *
 * @param {Array<MeetingArtifact> | undefined} existingArtifacts Artifacts mapping to the same meeting object
 * @param {Array<MeetingArtifact>} newArtifacts Meeting artifacts returned by the service tied to the item
 * @returns Parsed meeting artifacts to be consumed by the client
 */
export function getMeetingObjects(existingArtifacts, newArtifacts, meetingStartTime) {
    var mergedArtifacts = (existingArtifacts || []).concat(newArtifacts);
    var uniqueArtifacts = [];
    mergedArtifacts.forEach(function (artifact) {
        var index = uniqueArtifacts.findIndex(function (x) { return x.id === artifact.id; });
        if (index === -1) {
            uniqueArtifacts.push(artifact);
        }
    });
    return uniqueArtifacts
        .map(function (artifact) {
        if (artifact.title && artifact.web_url && artifact.type) {
            return {
                id: artifact.id,
                impressionId: 'MeetingArtifactImpressionId',
                title: artifact.title,
                attribution: '',
                app: artifact.type,
                fileType: getTypeFromFileTypeName(artifact.type),
                webUrl: artifact.web_url,
                url: artifact.web_url,
                extension: artifact.extension,
                application: artifact.type,
                meetingStartTime: meetingStartTime,
            };
        }
        return undefined;
    })
        .filter(function (artifact) { return !!artifact; });
}
export function getApplicationFromType(item) {
    var application = '';
    if (item.type) {
        //item.source is the App id for MetaOS App's
        if (item.type === 'Custom') {
            application = item.source;
        }
        else {
            application = item.type;
        }
    }
    return application;
}
//# sourceMappingURL=ParseUtilities.js.map